import { Component, OnInit } from '@angular/core';
import { TdLoadingService } from '@covalent/core';

import { Employee } from '../../shared/employee';
import { IdeaService } from '../../services/index';

@Component({
  selector: 'app-author-list',
  templateUrl: './author-list.component.html',
  styleUrls: ['./author-list.component.scss']
})
export class AuthorListComponent implements OnInit {
  /**
   * List of employees
   */
  employees: Employee[] = [];

  /**
   * Constructor
   *
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    private _loadingService: TdLoadingService,
    private _ideaService: IdeaService
  ) {}

  /**
   * Init
   */
  ngOnInit() {
    this._loadingService.register();
    let data = Object.assign({ statusIds: this._statuses }, {});
    this._ideaService
      .employeeSearchWithCounts(data)
      .finally(() => {
        this._loadingService.resolve();
      })
      .subscribe((res: any) => {
        if (res['errors']) {
        } else if (res['result'].data) {
          this.employees = res['result'].data.filter(
            (employee: Employee) => employee.count > 0
          );
        }
      });
  }

  /**
   * Returns a list of statuses to filter categories
   */
  private get _statuses() {
    let statuses = [];
    this.statuses.forEach((status) =>
      statuses.push(status.statusId, ...status.includes)
    );
    return statuses;
  }

  /**
   * List of statuses/tabs
   */
  get statuses() {
    return IdeaService.statuses.filter((status) => !status.profile);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/author-list/author-list.component.ts